import React, { useState, useEffect } from 'react';
import BackArrow from '../../BackArrow';
import { host_url } from '../../App';
import './Inventar.css';

function Inventar() {
  const [items, setItems] = useState([]);
  const [laden, setLaden] = useState(true);

  useEffect(() => {
    fetch(`${host_url}/logistik/inventar`)
      .then(r => r.json())
      .then(data => { setItems(data); setLaden(false); })
      .catch(() => setLaden(false));
  }, []);

  return (
    <div className="inventar-page">
      <div className="page-header">
        <BackArrow to="/freizeit" />
        <h1>Inventar</h1>
      </div>

      <p className="inventar-intro">
        Folgende Geräte stehen während des Camps zum Ausleihen bereit.
        Wende dich für die Ausleihe ans Logistik-Team.
      </p>

      {laden ? (
        <div className="inventar-laden">Wird geladen …</div>
      ) : items.length === 0 ? (
        <div className="inventar-leer">Noch keine Geräte eingetragen.</div>
      ) : (
        <div className="geraete-liste">
          {items.map(item => (
            <div key={item.ID} className="geraet-card">
              <div className="geraet-anzahl">{item.Anzahl}×</div>
              <div className="geraet-info">
                <div className="geraet-name">{item.Name}</div>
                {item.Beschreibung && (
                  <div className="geraet-beschreibung">{item.Beschreibung}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Inventar;
